import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { themeGet } from '@styled-system/theme-get';
import Swal from 'sweetalert2';

import { TilesDigestDateInput } from './TilesDigestDateInput.jsx';
import Modal from '../../../shared/Modal';
import { Button } from '../../../shared/FormStyles/Button';

const StyledParagraph = styled.p`
  font-size: 14px;
  font-family: 'Montserrat';
  font-weight: 400;
  color: ${themeGet('colors.black.80')};
  margin: 0 13px 16px;
  text-align: left;
`;

const StyledTitle = styled.h2`
  font-size: 20px;
  font-family: 'Montserrat';
  font-weight: 600;
  color: ${themeGet('colors.black.100')};
  margin: 0 13px 8px;
  text-align: left;
`;

const StyledDiv = styled.div`
  display: inline-block;
`;

const CalendarWrapper = styled.div`
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
`;

const ButtonGroup = styled.div`
  display: flex;
  border-top: 1px solid ${themeGet('colors.black.10')};
  padding: 8px;
  margin: 16px 0 0;
  justify-content: flex-end;
`;

const StyledSpan = styled.span`
  position: ${props => props.position || 'inherit'};
`;

export class NewTilesDigestModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: props.initialDate,
    };

    this.openAddTilesDigestModal = this.openAddTilesDigestModal.bind(this);
  }

  render() {
    return (
      // This span tag is necessary to create a digest on tile drop
      <StyledSpan
        position={this.props.position}
        onClick={this.openAddTilesDigestModal}
      >
        {this.props.children}
      </StyledSpan>
    );
  }

  openAddTilesDigestModal() {
    Modal({
      component: (
        <StyledDiv>
          <StyledTitle>Create Digest</StyledTitle>
          <StyledParagraph>Select a date and save to continue</StyledParagraph>
          <CalendarWrapper>
            <TilesDigestDateInput
              value={this.state.date}
              onChange={this.handleChange.bind(this)}
            />
            <ButtonGroup>
              <Button variant="tertiary" onClick={() => Swal.close()}>
                Cancel
              </Button>
              <Button
                variant="containedBlue"
                ml="8px"
                type="button"
                onClick={() => {
                  Swal.clickConfirm();
                }}
              >
                Save
              </Button>
            </ButtonGroup>
          </CalendarWrapper>
        </StyledDiv>
      ),
      width: '394px',
      padding: '24px 13px 16px',
    }).then(result => {
      if (result.value) {
        this.props.onConfirm(this.state.date);
      } else if (
        result.dismiss === Swal.DismissReason.cancel ||
        result.dismiss === Swal.DismissReason.backdrop
      ) {
        this.props.onCancel();
      }
    });
  }

  handleChange(value) {
    this.setState({ date: value });
  }
}

NewTilesDigestModal.defaultProps = {
  initialDate: moment().format('DD-MM-YYYY'),
  onCancel: () => null,
};
